import { ReactNode } from 'react';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { NavLink as Link } from 'components/RouterLink';
import { colors, cssBreakpoints, transition } from 'theme/theme';
import { trackClicked } from 'utils/analytics/track/trackClicked';

import { PAGE_HEADER_NAV_MAP } from './PageHeaderConstants';

type Props = {
  isStaff?: boolean;
  type: string;
  to: string | { pathname: string; state: { redirectToContent?: boolean } };
  onClick?: () => void;
  children: ReactNode;
};

export const PageHeaderNavLink = styled(
  ({ isStaff, type, to, ...props }: Props) =>
    (isStaff &&
      ['CMS', 'HOME', 'USER_DASHBOARD', 'ORG_DASHBOARD'].includes(type)) ||
    (type === 'BLOG' && CURRENT_LOCALE === 'es') ? (
      <Box
        component="a"
        classes={['flex', 'align-center']}
        href={to}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    ) : (
      <Box
        component={Link}
        classes={['flex', 'align-center']}
        to={to}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        onClick={() => {
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          trackClicked(`${PAGE_HEADER_NAV_MAP[type]} Link Header`);

          if (props.onClick) {
            props.onClick();
          }
        }}
      />
    ),
)<{ $active?: boolean; $navInactive?: boolean; $fullSize?: boolean }>`
  position: relative;
  padding: ${(2.5 - 1.375) / 2}em 0;
  height: 100%;
  overflow: hidden;
  color: ${colors.mediumContentGrey};
  opacity: ${(props) => (props.$navInactive ? 1 : 0.7)};
  font-size: inherit;
  line-height: 1.375;
  text-align: left;
  transition: opacity ${transition};
  &::after {
    content: '';
    position: absolute;
    transform: translateY(100%);
    bottom: 0;
    left: 0;
    width: 100%;
    height: ${(props) => (props.$fullSize ? 4 : 2)}px;
    background: ${colors.brandBlue};
  }
  ${(props) =>
    props.$active &&
    `
    opacity: 1;
    &::after {
      transform: translateY(0);
    }
  `}
  &,
  &:hover,
  &:focus {
    text-decoration: none;
  }
  &:hover {
    opacity: 1;
    color: ${colors.brandBlue};
  }
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    width: 100%;
    padding: 0;
    text-align: center;
    line-height: inherit;
  }
`;
